import React from 'react'
import { Spinny } from '../components/Nav/Spinny';
import { useReduxSelector } from '../redux/hooks';
import { RevUserContext } from './UserContext';
import { Api } from '../redux/api/BaseApi';
import { createUserManager } from 'redux-oidc';
import { oAuthSettings } from "../components/Auth/AuthSettings";
import ErrorCard from '../components/Common/ErrorCard';
import Cookies from 'js-cookie';

export const RevelationContext = (props) => {
    const stateUser = useReduxSelector((state) => state.auth.user);
    const mimicUid = useReduxSelector((state) => state.revI.mimicUid);
    //Wait for the user token to be loaded into state before calling the API
    const { data: profile, error } = Api.useGetUserProfileQuery(mimicUid ? mimicUid : undefined, { skip: !stateUser })
    if (error) {
        console.log('RevelationContext error', error)
    }
    if (error && (error['originalStatus'] === 401 || error['originalStatus'] === 403)) {
        //Reauthenticate
        //return <div>error:{JSON.stringify(error)}</div>
        let newUserManager = createUserManager(oAuthSettings)
        newUserManager.signoutRedirect();

        return <Spinny />
    }

    if (error)
        return <ErrorCard message='Error returned from Revelation API' details={JSON.stringify(error)} />


    if (!profile && !error) {
        //console.log('RevelationContext', profile, error, isSuccess, stateUser)
        return <Spinny />
    }
    if (profile && profile?.Tenant_Uid)
        Cookies.set('RevTenantUid', profile?.Tenant_Uid);

    const primarystyle = `.rev-primary-button, .rev-primary-button button, .rev-primary-button ul.k-menu-group
    , .rev-primary-button ul.k-menu-group:hover{
            background-color: ${profile?.Nav_Hex_Color};  
            color:#fff;
        }
        .rev-primary-button button:hover,
        .rev-primary-button:hover {
            filter: brightness(80%);
            background-color: ${profile?.Nav_Hex_Color};  
            color:#fff;
        }`

    const coolWindowStyle = `.k-window.cool-window .k-window-titlebar,
        .cool-window > .k-window .k-window-titlebar{
            background-color: ${profile?.Nav_Hex_Color};  
            color:#fff;
        }
        .k-window.cool-window, .cool-window > .k-window{background-color: #ddd;}`
    return (
        <>
            <RevUserContext.Provider value={profile}>
                <style>{primarystyle}
                    {coolWindowStyle}
                </style>
                <main
                    className="relative min-h-screen flex flex-col"
                    style={{ position: "relative" }}      >
                    {props.children}
                </main>
            </RevUserContext.Provider>
        </>
    )
}
